const messages = {
  sw: {
    translations: {
      signup: {
        title: "Jisajili",
        toasts: {
          success: "Mtumiaji ameundwa! Tafadhali ingia!",
          fail: "Hitilafu ya kuunda mtumiaji. Angalia data iliyoripotiwa.",
        },
        form: {
          name: "Jina",
          email: "Barua pepe",
          password: "Nywila",
        },
        buttons: {
          submit: "Jisajili",
          login: "Una akaunti? Ingia!",
        },
      },
      login: {
        title: "Ingia",
        form: {
          email: "Barua pepe",
          password: "Nywila",
        },
        buttons: {
          submit: "Ingia",
          register: "Huna akaunti? Jisajili!",
        },
      },
      auth: {
        toasts: {
          success: "Umeingia!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tiketi leo: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Inahudumia",
          },
          waiting: {
            title: "Inasubiri",
          },
          closed: {
            title: "Imefungwa",
          },
        },
      },
      connections: {
        title: "Miunganisho",
        toasts: {
          deleted: "Muunganisho wa WhatsApp umefutwa!",
        },
        confirmationModal: {
          deleteTitle: "Futa",
          deleteMessage: "Una uhakika? Haiwezi kurudishwa.",
          disconnectTitle: "Tenganisha",
          disconnectMessage: "Una uhakika? Utahitaji kusoma QR Code tena.",
        },
        buttons: {
          add: "Ongeza WhatsApp",
          disconnect: "Tenganisha",
          tryAgain: "Jaribu Tena",
          qrcode: "QR CODE",
          newQr: "QR CODE Mpya",
          connecting: "Inaunganisha",
        },
        toolTips: {
          disconnected: {
            title: "Imeshindwa kuanzisha kikao cha WhatsApp",
            content: "Hakikisha simu yako imeunganishwa kwenye mtandao na ujaribu tena, au omba QR Code mpya",
          },
          qrcode: {
            title: "Inasubiri kusoma QR Code",
            content: "Bonyeza kitufe cha 'QR CODE' na kusoma QR Code kwa simu yako kuanzisha kikao",
          },
          connected: {
            title: "Muunganisho umeanzishwa",
          },
          timeout: {
            title: "Muunganisho na simu umepotea",
            content: "Hakikisha simu yako imeunganishwa na WhatsApp iko wazi, au bonyeza 'Tenganisha' kupata QR Code mpya",
          },
        },
        table: {
          name: "Jina",
          status: "Hali",
          lastUpdate: "Sasisho la Mwisho",
          default: "Msingi",
          actions: "Vitendo",
          session: "Kikao",
        },
      },
      whatsappModal: {
        title: {
          add: "Ongeza WhatsApp",
          edit: "Hariri WhatsApp",
        },
        form: {
          name: "Jina",
          default: "Msingi",
        },
        buttons: {
          okAdd: "Ongeza",
          okEdit: "Hifadhi",
          cancel: "Ghairi",
        },
        success: "WhatsApp imehifadhiwa.",
      },
      qrCode: {
        message: "Soma QrCode kuanzisha kikao",
      },
      contacts: {
        title: "Wasiliani",
        toasts: {
          deleted: "Wasiliani amefutwa!",
        },
        searchPlaceholder: "Tafuta...",
        confirmationModal: {
          deleteTitle: "Futa",
          importTitlte: "Ingiza wasiliani",
          deleteMessage: "Una uhakika kutaka kufuta wasiliani huyu? Tiketi zote zinazohusiana zitapotea.",
          importMessage: "Unataka kuingiza wasiliani wote kutoka kwa simu?",
        },
        buttons: {
          import: "Ingiza Wasiliani",
          add: "Ongeza Wasiliani",
        },
        table: {
          name: "Jina",
          whatsapp: "WhatsApp",
          email: "Barua pepe",
          actions: "Vitendo",
        },
      },
      contactModal: {
        title: {
          add: "Ongeza wasiliani",
          edit: "Hariri wasiliani",
        },
        form: {
          mainInfo: "Maelezo ya wasiliani",
          extraInfo: "Maelezo ya ziada",
          name: "Jina",
          number: "Nambari ya WhatsApp",
          email: "Barua pepe",
          extraName: "Jina la sehemu",
          extraValue: "Thamani",
        },
        buttons: {
          addExtraInfo: "Ongeza maelezo",
          okAdd: "Ongeza",
          okEdit: "Hifadhi",
          cancel: "Ghairi",
        },
        success: "Wasiliani amehifadhiwa.",
      },
      quickAnswersModal: {
        title: {
          add: "Ongeza Jibu la Haraka",
          edit: "Hariri Jibu la Haraka",
        },
        form: {
          shortcut: "Mkato",
          message: "Jibu la Haraka",
        },
        buttons: {
          okAdd: "Ongeza",
          okEdit: "Hifadhi",
          cancel: "Ghairi",
        },
        success: "Jibu la Haraka limehifadhiwa.",
      },
      queueModal: {
        title: {
          add: "Ongeza lebo",
          edit: "Hariri lebo",
        },
        form: {
          name: "Jina",
          color: "Rangi",
          greetingMessage: "Ujumbe wa Salamu",
        },
        buttons: {
          okAdd: "Ongeza",
          okEdit: "Hifadhi",
          cancel: "Ghairi",
        },
      },
      userModal: {
        title: {
          add: "Ongeza mwanachama",
          edit: "Hariri mwanachama",
        },
        form: {
          name: "Jina",
          email: "Barua pepe",
          password: "Nywila",
          profile: "Jukumu",
          whatsapp: "Muunganisho wa Msingi",
        },
        buttons: {
          okAdd: "Ongeza",
          okEdit: "Hifadhi",
          cancel: "Ghairi",
        },
        success: "Mtumiaji amehifadhiwa.",
      },
      chat: {
        noTicketMessage: "Chagua tiketi kuanza mazungumzo.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Mpya",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Foleni",
      },
      tickets: {
        toasts: {
          deleted: "Tiketi ulikuwa umechaguliwa imefutwa.",
        },
        notification: {
          message: "Ujumbe kutoka",
        },
        tabs: {
          open: { title: "Kikasha" },
          closed: { title: "Iliyosuluhiwa" },
          search: { title: "Tafuta" },
        },
        search: {
          placeholder: "Tafuta tiketi na ujumbe.",
        },
        buttons: {
          showAll: "Zote",
        },
      },
      transferTicketModal: {
        title: "Hamisha Tiketi",
        fieldLabel: "Andika kutafuta watumiaji",
        fieldQueueLabel: "Hamisha kwenye lebo",
        fieldConnectionLabel: "Hamisha kwenye muunganisho",
        fieldQueuePlaceholder: "Tafadhali chagua lebo",
        fieldConnectionPlaceholder: "Tafadhali chagua muunganisho",
        noOptions: "Hakuna mtumiaji aliyepatikana",
        buttons: {
          ok: "Hamisha",
          cancel: "Ghairi",
        },
      },
      ticketsList: {
        pendingHeader: "Mpya",
        assignedHeader: "Inafanywa kazi",
        noTicketsTitle: "Hakuna kitu hapa!",
        noTicketsMessage: "Hakuna tiketi zilizopatikana.",
        connectionTitle: "Muunganisho unaotumika sasa.",
        buttons: {
          accept: "Kubali",
        },
      },
      newTicketModal: {
        title: "Unda Tiketi",
        fieldLabel: "Andika kutafuta wasiliani",
        add: "Ongeza",
        buttons: {
          ok: "Hifadhi",
          cancel: "Ghairi",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashibodi",
          connections: "Miunganisho",
          tickets: "Tiketi",
          contacts: "Wasiliani",
          quickAnswers: "Majibu ya Haraka",
          queues: "Foleni",
          administration: "Usimamizi",
          users: "Watumiaji",
          settings: "Mipangilio",
        },
        appBar: {
          user: {
            profile: "Wasifu",
            logout: "Toka",
          },
        },
      },
      notifications: {
        noTickets: "Hakuna arifa.",
      },
      queues: {
        title: "Foleni",
        table: {
          name: "Jina",
          color: "Rangi",
          greeting: "Ujumbe wa salamu",
          actions: "Vitendo",
        },
        buttons: {
          add: "Ongeza lebo",
        },
        confirmationModal: {
          deleteTitle: "Futa",
          deleteMessage: "Una uhakika? Haiwezi kurudishwa!",
        },
      },
      queueSelect: {
        inputLabel: "Foleni",
      },
      quickAnswers: {
        title: "Majibu ya Haraka",
        table: {
          shortcut: "Mkato",
          message: "Jibu la Haraka",
          actions: "Vitendo",
        },
        buttons: {
          add: "Ongeza Jibu la Haraka",
        },
        toasts: {
          deleted: "Jibu la Haraka limefutwa.",
        },
        searchPlaceholder: "Tafuta...",
        confirmationModal: {
          deleteTitle: "Una uhakika kutaka kufuta Jibu la Haraka hili: ",
          deleteMessage: "Kitendo hiki hakiwezi kurudishwa.",
        },
      },
      users: {
        title: "Watumiaji",
        table: {
          name: "Jina",
          email: "Barua pepe",
          profile: "Jukumu",
          whatsapp: "Muunganisho wa Msingi",
          actions: "Vitendo",
        },
        buttons: {
          add: "Ongeza mwanachama",
        },
        toasts: {
          deleted: "Mwanachama amefutwa.",
        },
        confirmationModal: {
          deleteTitle: "Futa",
          deleteMessage: "Data yote ya mtumiaji itapotea. Tiketi zilizo wazi zitawekwa kama Mpya.",
        },
      },
      settings: {
        success: "Mipangilio imehifadhiwa.",
        title: "Mipangilio",
        settings: {
          userCreation: {
            name: "Uundaji wa mtumiaji",
            options: {
              enabled: "Imewezeshwa",
              disabled: "Imezimwa",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Imepewa:",
          buttons: {
            return: "Rudisha",
            resolve: "Suluhisha",
            reopen: "Fungua tena",
            accept: "Kubali",
          },
        },
      },
      ticketMessagesSearch: {
        placeholder: "Tafuta ujumbe",
        tooltip: "Tafuta kwenye mazungumzo",
        results: "Matokeo {{count}}",
        noResults: "Hakuna ujumbe uliopatikana",
        notFound: "Ujumbe haukupatikana",
        loadMore: "Pakia matokeo zaidi",
      },
      messagesInput: {
        placeholderOpen: "Andika ujumbe au bonyeza '/' kutumia majibu ya haraka",
        placeholderClosed: "Fungua tena au kubali tiketi hii kutuma ujumbe.",
      },
      contactDrawer: {
        header: "Maelezo ya wasiliani",
        buttons: {
          edit: "Hariri wasiliani",
        },
        extraInfo: "Maelezo mengine",
      },
      ticketOptionsMenu: {
        delete: "Futa",
        transfer: "Hamisha",
        confirmationModal: {
          title: "Futa tiketi #",
          titleFrom: "kutoka kwa wasiliani ",
          message: "Tahadhari! Ujumbe wote unaohusiana na tiketi utapotea.",
        },
        buttons: {
          delete: "Futa",
          cancel: "Ghairi",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Sawa",
          cancel: "Ghairi",
        },
      },
      messageOptionsMenu: {
        messageInfo: "Maelezo ya ujumbe",
        reply: "Jibu",
        copy: "Nakili",
        react: "Jibu kwa emoji",
        forward: "Peleka mbele",
        pin: "Weka pini",
        star: "Nyota",
        delete: "Futa",
        confirmationModal: {
          title: "Futa ujumbe?",
          message: "Kitendo hiki hakiwezi kurudishwa.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Lazima kuwe na muunganisho mmoja wa msingi wa WhatsApp.",
        ERR_NO_DEF_WAPP_FOUND: "Hakuna WhatsApp ya msingi iliyopatikana. Angalia ukurasa wa miunganisho.",
        ERR_WAPP_NOT_INITIALIZED: "Kikao hiki cha WhatsApp hakijaanzishwa. Angalia ukurasa wa miunganisho.",
        ERR_WAPP_CHECK_CONTACT: "Imeshindwa kuangalia wasiliani wa WhatsApp. Angalia ukurasa wa miunganisho.",
        ERR_WAPP_INVALID_CONTACT: "Hii si nambari halali ya WhatsApp.",
        ERR_WAPP_DOWNLOAD_MEDIA: "Imeshindwa kupakua maudhui kutoka WhatsApp. Angalia ukurasa wa miunganisho.",
        ERR_INVALID_CREDENTIALS: "Hitilafu ya uthibitisho. Tafadhali jaribu tena.",
        ERR_SENDING_WAPP_MSG: "Hitilafu ya kutuma ujumbe wa WhatsApp. Angalia ukurasa wa miunganisho.",
        ERR_DELETE_WAPP_MSG: "Imeshindwa kufuta ujumbe kutoka WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Tayari kuna tiketi iliyofunguliwa kwa wasiliani huyu.",
        ERR_SESSION_EXPIRED: "Kikao kimeisha. Tafadhali ingia tena.",
        ERR_USER_CREATION_DISABLED: "Uundaji wa mtumiaji umezimwa na msimamizi.",
        ERR_NO_PERMISSION: "Huna ruhusa ya kufikia rasilimali hii.",
        ERR_DUPLICATED_CONTACT: "Wasiliani mwenye nambari hii tayari yuko.",
        ERR_NO_SETTING_FOUND: "Hakuna mipangilio iliyopatikana.",
        ERR_NO_CONTACT_FOUND: "Hakuna wasiliani aliyepatikana.",
        ERR_NO_TICKET_FOUND: "Hakuna tiketi iliyopatikana.",
        ERR_NO_USER_FOUND: "Hakuna mtumiaji aliyepatikana.",
        ERR_NO_WAPP_FOUND: "Hakuna WhatsApp iliyopatikana.",
        ERR_CREATING_MESSAGE: "Hitilafu ya kuunda ujumbe kwenye hifadhidata.",
        ERR_CREATING_TICKET: "Hitilafu ya kuunda tiketi kwenye hifadhidata.",
        ERR_FETCH_WAPP_MSG: "Hitilafu ya kupata ujumbe kwenye WhatsApp, huenda ni wa zamani sana.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Rangi hii inatumika tayari, chagua nyingine.",
        ERR_WAPP_GREETING_REQUIRED: "Ujumbe wa salamu unahitajika ikiwa kuna zaidi ya lebo moja.",
      },
    },
  },
};

export { messages };
